<template>
    <div class="v-nav-mobile-menu" v-click-outside="onClickOutside">
        <div class="slide-menu" id="tourcompass-menu">
            <div class="controls" :style="{'height': heightInStatic}">
<!--            <div class="controls">-->
                <div style="width: 100%; display: block;">
                    <button @click="highlightOnBack" style="float: left; padding-right: 35px; width: 35%; " type="button" class="btn slide-menu__control" data-action="back">
                        <div id="back-btn"><i class="u-fa u-fa-angle-left back-title"></i>&nbsp;{{ t('Back') }}</div>
                    </button>
                    <button @click="highlightOnClose" type="button" style="z-index: auto; float: right; position: relative; width: 50px;" class="btn slide-menu__control" data-action="close" ref="closeAllMenu">
                        <div id="close-btn" style="margin-top: 5px; margin-right: 5px; width: 30px; height: 30px;">
                            <svg style="position: absolute; z-index: -1; right: 12px; top: 22px;" role="presentation" width="21" height="21" viewBox="0 0 24 24" class="icon--inline icon">
                                <path fill="#ff6700" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
                            </svg>
                        </div>
                    </button>
                </div>
            </div>
            <div class="v-nav-menu" :style="{'height': heightToHide}">
                <div class="v-nav-menu__scroll_area" :style="{'height': innerHeightToHide}">
<!--            <div class="v-nav-menu">
                <div class="v-nav-menu__scroll_area">-->
                    <slot>
                        <!---->
                    </slot>
                </div>
            </div>
        </div>
        </div>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
export default class NavMobileMenuSlider extends BaseComponent {
    public readonly $refs: {
        closeAllMenu: any,
    };

    protected heightStatic: number = 35;
    protected heightInStatic: string = '0';
    protected heightToHide: string = '0';
    protected innerHeightToHide: string = '0';

    protected mounted(): void {
        this.heightToHide = (window.innerHeight - 41) + 'px';
        this.innerHeightToHide = (window.innerHeight - 42) + 'px';
        this.heightInStatic = this.heightStatic + 'px';
        window.addEventListener('orientationchange', () => {
            setTimeout(() => {
                this.heightToHide = (window.innerHeight - 41) + 'px';
                this.innerHeightToHide = (window.innerHeight - 42) + 'px';
            }, 200);
        });
    }

    protected highlightOnClose() {
        const exitBtnNode = document.getElementById('close-btn');
        const exitBtn: HTMLElement = exitBtnNode as HTMLElement;
        exitBtn.style.backgroundColor = 'rgba(240, 215, 205, .6)';
        setTimeout(() => {
            exitBtn.style.backgroundColor = 'transparent';
        }, 200);
    }

    protected highlightOnBack() {
        const backBtnNode = document.getElementById('back-btn');
        const backBtn: HTMLElement = backBtnNode as HTMLElement;
        backBtn.style.backgroundColor = '#fae4cd';
        setTimeout(() => {
            backBtn.style.backgroundColor = 'transparent';
        }, 300);
        this.scrollToTop();
    }

    protected scrollToTop() {
        const scrollBlockNone = document.getElementsByClassName('slide-menu__submenu--active');
        if (scrollBlockNone[0]) {
            const scrollBlock: HTMLElement = scrollBlockNone[0] as HTMLElement;
            scrollBlock.scrollIntoView();
        }
    }

    /**
     * @param event
     * @protected
     */
    protected onClickOutside(event) {
        const openMenuElement = document.getElementById('open-menu');
        if (openMenuElement) {
            if (openMenuElement.offsetParent !== null) {
                const el = document.getElementById('tourcompass-menu');
                if (el) {
                    const slideMenu: HTMLElement = el as HTMLElement;
                    if (slideMenu.style.transform && slideMenu.style.transform === 'translateX(0%)') {
                        if (!event.target.parentElement.classList.contains('v-nav-mobile-slide')) {
                            const elem = this.$refs.closeAllMenu as HTMLElement;
                            elem.click();
                            this.scrollToTop();
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss">
.v-nav-menu {
    width: 100%;
    overscroll-behavior: contain;
    overflow-y: scroll;
    overflow-x: hidden;
    z-index: 9;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &__scroll_area {
        overscroll-behavior: contain;
    }

    &::-webkit-scrollbar {
        display: none;
    }
}
</style>
